import React, { forwardRef } from 'react';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import { IBoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete/types';
import { useStyles as commonUseStyles } from '../../styles';
import { useStyles } from './styles';

export const UserAutocomplete = forwardRef<HTMLInputElement, IBoxFormAutocomplete>(({
  name, options, value, onChange, onBlur, defaultValue, label, multiple,
}, ref) => {
  const commonStyles = commonUseStyles();
  const styles = useStyles();
  return (
    <div className={`${commonStyles.commonInput} ${styles.autocomplete}`}>
      <BoxFormAutocomplete
        ref={ref}
        name={name}
        label={label}
        value={value}
        options={options}
        onChange={onChange}
        multiple={multiple}
        onBlur={onBlur}
        defaultValue={defaultValue}
      />
    </div>
  );
});
